import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MagicService from '@/service/magic';
export default {
  data: function data() {
    return {
      requesting: false
    };
  },
  computed: {
    state: function state() {
      return this.$store.state.bookCouponState;
    }
  },
  methods: {
    lottery: function lottery() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var moduleId, res, code;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.requesting) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _this.requesting = true;
                moduleId = window.setting.魔方配置.书券ID;
                _context.prev = 4;
                _context.next = 7;
                return MagicService.receive({
                  module_id: moduleId
                });

              case 7:
                res = _context.sent;

                if (!res.data) {
                  _context.next = 22;
                  break;
                }

                code = +res.data.sys_code;

                if (!(code === 0)) {
                  _context.next = 14;
                  break;
                }

                _this.toast('领取成功');

                _context.next = 19;
                break;

              case 14:
                if (!(code === -903)) {
                  _context.next = 18;
                  break;
                }

                _this.toast('已领取');

                _context.next = 19;
                break;

              case 18:
                throw {
                  msg: res.msg,
                  code: code
                };

              case 19:
                _this.$store.dispatch('getBookCouponState');

                _context.next = 23;
                break;

              case 22:
                _this.toast(res.msg || '系统开小差了，请稍后重试');

              case 23:
                _context.next = 28;
                break;

              case 25:
                _context.prev = 25;
                _context.t0 = _context["catch"](4);

                _this.toast(_context.t0.msg || _context.t0.message || "\u7CFB\u7EDF\u5F00\u5C0F\u5DEE\u4E86\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5(".concat(_context.t0.code, ")"));

              case 28:
                _this.requesting = false;

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 25]]);
      }))();
    },
    toRead: function toRead() {
      var link = window.setting.魔方配置.书券跳转链接;
      this.openUrl(link);
    }
  }
};